
import { defineComponent } from 'vue';
import { AppError } from './app-error';

export default defineComponent({
  name: 'toast-error',
  props: { error: void 0 as AppError | any },
});
